import { Controller } from "@hotwired/stimulus"

// MS50 #3003 — CSP-safe copy-to-clipboard controller.
//
// Replaces inline `onclick="navigator.clipboard.writeText(...)"` handlers (and
// nonce-less inline copy functions) the enforcing nonce CSP (#1222) blocked.
// Put `data-controller="clipboard"` on the trigger, the text to copy in
// `data-clipboard-text-value`, and wire `data-action="click->clipboard#copy"`.
// Optionally set `data-clipboard-success-content-value` for brief post-copy
// feedback swapped into the trigger's contents.
export default class extends Controller {
  static values = { text: String, successContent: String }

  copy(event) {
    event.preventDefault()

    navigator.clipboard.writeText(this.textValue).then(
      () => this.#feedback(),
      () => window.alert("Failed to copy. Please copy manually.")
    )
  }

  #feedback() {
    if (!this.hasSuccessContentValue) return

    const original = this.element.innerHTML
    this.element.innerHTML = this.successContentValue
    setTimeout(() => {
      this.element.innerHTML = original
    }, 2000)
  }
}
